import {FormPageProps} from "@/components/WdiBus/FormPage";
import {ProForm, ProFormInstance} from "@ant-design/pro-form";
import React, {useEffect, useRef, useState} from "react";
import {ApplyFooter, ApplyFooterType} from "@/components/WdiBus/ApplyFooter";
import ProductPolicyBasicApplyPanel from "@/pages/policy/ProductPolicyApply/components/basic";
import ProductPolicyDetailApplyPanel from "@/pages/policy/ProductPolicyApply/components/detail";
import ProductPolicySoldToApplyPanel from "@/pages/policy/ProductPolicyApply/components/SoldTo/soldTo";
import {Enum} from "@/enums/system";
import {ResponseStatus} from "@/utils/request";
import {message} from "antd";
import {ProductPolicy} from "@/services/policy/productpolicy";
import {wdiCore, WdiModalAppResult} from "@/components/WdiControls";
import {FileUploadUtility} from "@/components/WdiControls/WdiFileUpload";
import moment from "moment";
import {initPageContext, PolicyFieldNames} from "@/pages/policy/ProductPolicyApply/data";
import {WdiSelectFormat} from "@/components/WdiControls/WdiSelect";
import {
  ProductPolicyTargetForApplyPanel
} from "@/pages/policy/ProductPolicyApply/components/PolicyTarget/ProductPolicyTargetPanel";


export enum OpenModeEnum {
  CREATE = 1,
  UPDATE = 2,
  UPDATE_PARTLY = 3,
  VIEW = 4
}

const ProductPolicyApplyApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [openMode, setOpenMode] = useState<OpenModeEnum>(OpenModeEnum.CREATE);
  const [soldToDataSource, setSoldToDataSource] = useState<Array<API.ProductPolicySoldTo>>([]);
  const [targetDataSource, setTargetDataSource] = useState<Array<API.ProductPolicyTargetVo>>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [editorRef,setEditorRef] = useState<any>();

  const validateProductPolicy = (values: any) => {
    const result: WdiModalAppResult = {code: ResponseStatus.UNKNOWN};
    const {fileInfo} = values;
    if (values && values.errorFields && values.errorFields.length) {
      result.message = '参数异常!';
      return result;
    }

    if (FileUploadUtility.isUploading(fileInfo)) {
      result.message = '附件正在上传中!';
      return result;
    }
    if (FileUploadUtility.isError(fileInfo)) {
      result.message = '附件存在错误文件!';
      return result;
    }

    result.code = ResponseStatus.SUCCESS;
    return result;
  }

  useEffect(() => {
    (async () => {
      if (props.setPageTitle) {
        let title = "新建政策";
        if (props.data?.productPolicyId) {
          title = '编辑政策';
        }
        props.setPageTitle(title);
      }

      //编辑模式
      if (props.data?.productPolicyId) {

        const result: WdiModalAppResult = await initPageContext(props.data?.productPolicyId)
        if (result.code != ResponseStatus.SUCCESS) return;

        if ("ReeditPolicyButton" === props.data.button.key) {
          // 修改政策
          const modeResult = await ProductPolicy.getPolicyOpenMode(props.data?.productPolicyId);
          if (modeResult.code != ResponseStatus.SUCCESS) return;
          setOpenMode(modeResult.data as OpenModeEnum);
        }

        if ("CopyButton" === props.data.button.key) {
          // 复制并编辑
          setOpenMode(OpenModeEnum.CREATE);
          // 政策期间设置为空
          formRef.current?.setFieldsValue(Object.assign(result.data, {
            productPolicyId: null,
            policyDate: [null, null]
          }));
        }

        // 政策期间设置为空
        formRef.current?.setFieldsValue(result.data);
        setSoldToDataSource(result.data?.productPolicySoldToList ?? []);
        setTargetDataSource(result.data?.productPolicyTargetList ?? []);
        setIsLoaded(true);
      }
    })()
  }, [props.data]);

  const getProductPolicy = () => {
    const values =  formRef.current?.getFieldsValue();
    const productPolicy:API.ProductPolicy = {
      productPolicyId: WdiSelectFormat.getvalue(values.productPolicyId),
      bohqId: WdiSelectFormat.getvalue(values.bohqId),
      startDate: (values.policyDate && values.policyDate[0]) ? moment(values.policyDate[0]).format('YYYY-MM-DD') : '',
      endDate: (values.policyDate && values.policyDate[1]) ? moment(values.policyDate[1]).format('YYYY-MM-DD') : '',
    }
    return productPolicy;
  }

  const getProductPolicyProduct = (values: any, fieldName: PolicyFieldNames, type: Enum.TermsProductTypeEnum) => {
    if (!values || !values[fieldName]) return [];
    return values[fieldName]?.map((item: any) => ({
      productId: WdiSelectFormat.getvalue(item),
      productName: item.label,
      termsProductType: type
    }));
  }

  return (
    <ProForm className={'wdi-form'} formRef={formRef} submitter={{
      render: () => {
        return (
          <ApplyFooter
            setLoading={props.setLoading}
            submitBackUrl={"/policy/policyproduct"}
            hiddenButton={[ApplyFooterType.Validate, ApplyFooterType.Draft]}
            callback={!props.callback ? undefined : () => {
              props.callback?.();
              props.onClose?.();
            }}
            doSubmit={async (type: number, forceSubmit: boolean) => {
              const values = await formRef.current?.validateFieldsReturnFormatValue?.();
              if (values && values.errorFields && values.errorFields.length) {
                return;
              }
              props?.setLoading?.(true);
              const remark = await editorRef?.current?.getHtml?.();
              const basicValidateResult: WdiModalAppResult = validateProductPolicy(values);
              if (basicValidateResult.code != ResponseStatus.SUCCESS) {
                props?.setLoading?.(false);
                message.error(basicValidateResult.message);
                return;
              }
              const fileInfo = FileUploadUtility.serialize(values.fileInfo);
              values.remark = remark;
              const productPolicy: API.ProductPolicy = {
                // 基本信息
                productPolicyId: values.productPolicyId,
                policyCode: values.policyCode,
                policyName: values.policyName,
                policyType: Enum.PolicyType.AUTO_CALC,
                bohqId: WdiSelectFormat.getvalue(values.bohqId),
                startDate: (values.policyDate && values.policyDate[0]) ? moment(values.policyDate[0]).format('YYYY-MM-DD') : '',
                endDate: (values.policyDate && values.policyDate[1]) ? moment(values.policyDate[1]).format('YYYY-MM-DD') : '',
                boIds: WdiSelectFormat.getvalue(values.boIds),
                ecIds: WdiSelectFormat.getvalue(values.ecIds),
                remark: values.remark,
                fileName: fileInfo.names,
                filePath: fileInfo.urls,
                formulaRebateOriginal: '',
                isAutoAppend: !!values.isAutoAppend,

                // 政策条款
                productIdsReach: WdiSelectFormat.getvalue(values.productIdsReach),
                productIdsRebate: WdiSelectFormat.getvalue(values.productIdsRebate),
                productIdsReachEx: WdiSelectFormat.getvalue(values.productIdsReachEx),
                productIdsRebateEx: WdiSelectFormat.getvalue(values.productIdsRebateEx),
                settlementFrequency: WdiSelectFormat.getvalue(values.settlementFrequency),
                paymentMethod: WdiSelectFormat.getvalue(values.paymentMethod),
                productIdsFg: WdiSelectFormat.getvalue(values.productIdsFg),
                policyCategoryId: WdiSelectFormat.getvalue(values.policyCategoryId),
                custTypeIds: WdiSelectFormat.getvalue(values.custTypeIds),
                bohqRebateTypeId: WdiSelectFormat.getvalue(values.bohqRebateTypeId),

                // 适用售达方/售达方组
                soldToCodes: soldToDataSource.map((item: API.ProductPolicySoldTo) => item.soldToCode).join(','),
              }

              if (!wdiCore.Object.IsNullOrUndefined(values.rebateStandard)) {
                values.rebateStandard.forEach((item: any) => {
                  if (item.isInit) {
                    productPolicy.formulaRebateOriginal = item.formulaRebate;
                  }
                });
              }

              const productPolicyPostParam: API.ProductPolicyPostParam = {
                productPolicy: productPolicy,
                openMode: openMode,
                oaForms: values?.oaForms ?? [],
                productPolicySoldTos: soldToDataSource,
                productPolicyTargets: targetDataSource,
                productPolicyRates: values.rebateStandard.filter((item: any) => !item.isInit),
                productPolicyProducts: [].concat(
                  getProductPolicyProduct(values, "productIdsReach", Enum.TermsProductTypeEnum.REACH),
                  getProductPolicyProduct(values, "productIdsRebate", Enum.TermsProductTypeEnum.REBATE),
                  getProductPolicyProduct(values, "productIdsReachEx", Enum.TermsProductTypeEnum.REACH_EX),
                  getProductPolicyProduct(values, "productIdsRebateEx", Enum.TermsProductTypeEnum.REBATE_EX)
                )
              }

              return await ProductPolicy.post(productPolicyPostParam).then((result: WdiModalAppResult) => {
                props?.setLoading?.(false);
                return result;
              });
            }}/>
        )
      }
    }}>
      <ProductPolicyBasicApplyPanel formRef={formRef}
                                    openMode={openMode}
                                    setEditorRef={setEditorRef}
      />

      <ProductPolicyDetailApplyPanel formRef={formRef}
                                     openMode={openMode}
                                     isLoaded={isLoaded}
      />

      <ProductPolicySoldToApplyPanel dataSource={soldToDataSource}
                                     openMode={openMode}
                                     getProductPolicy={getProductPolicy}
                                     onChange={(data: React.SetStateAction<API.ProductPolicySoldTo[]>) => setSoldToDataSource(data)}/>
      <br/>

      <ProductPolicyTargetForApplyPanel dataSource={targetDataSource}
                                     openMode={openMode}
                                     getProductPolicy={getProductPolicy}
                                     onChange={(data: React.SetStateAction<API.ProductPolicyTargetVo[]>) => setTargetDataSource(data)}/>
    </ProForm>
  )
}

export default ProductPolicyApplyApp;
